<template>
    <div
        class="hts-alert"
        :class="extendClass">
        <div
            class="alert shadow-lg"
            :class="typeClass">
            <div>
                <slot name="icon">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="stroke-current flex-shrink-0 h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24">
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </slot>
                <slot />
            </div>
            <div class="flex-none">
                <slot name="button" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { alert as types } from '~/components/types'

const props = defineProps({
  type: {
    type: String,
    default: ''
  },
  extendClass: String
})
const { type, extendClass } = toRefs(props)
const typeClass = computed(() => {
  const result: string = ''
  if (!type.value) {
    return result
  }
  if (!types.includes(type.value)) {
    return result
  }
  return result + ' alert-' + type.value
})
</script>
